import axios from 'axios';
import config from '../config/config';

const sendError = async (data: unknown) => {
  await axios.post(`${config.baseURL}/v1/shared/front-error`, data);
};

export default sendError;
